import React from 'react';
import PropTypes from 'prop-types';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import SubGroupsLabels from './c/subGroupsLabels/SubGroupsLabelsConnector';
import { EXCEL_FILE, getFileTypeCategory } from '../../../../helpers/fileTransferHelper';

class SubGroupsMenu extends React.Component {
  state = {
    showSubGroupOptions: false
  };

  handleCreateSubGroupClick = () => this.setState({ showSubGroupOptions: true });

  handleCancelLabelClick = () => this.setState({ showSubGroupOptions: false });

  render() {
    const { onNoSubGroupClick, onApplyLabels, fileExtension } = this.props;
    return (
      <div className="map-columns__subgroup-section">
        <h4>1. Create Data Subgroups <span className="map-columns__header_grayed">(Optional)</span></h4>
        <p>If Input Data contains subgroupings of values such as Header and Line data you can name the column and labels that define subgroupings and the system will maintain and display the groups in the mapping interface.</p>
        {
          !this.state.showSubGroupOptions &&
          <SovosButtonsGroup align="right" style={ { marginTop: 50 } } >
            <SovosRaisedButton onClick={ onNoSubGroupClick } color="secondary" disabled={ getFileTypeCategory(fileExtension) === EXCEL_FILE } >NO SUBGROUPS</SovosRaisedButton>
            <SovosRaisedButton onClick={ this.handleCreateSubGroupClick } color="secondary" disabled={ getFileTypeCategory(fileExtension) === EXCEL_FILE } >CREATE SUBGROUPS</SovosRaisedButton>
          </SovosButtonsGroup>
        }
        {
          this.state.showSubGroupOptions &&
          <SubGroupsLabels onApplyLabels={ onApplyLabels } onCancelLabels={ this.handleCancelLabelClick } />
        }
      </div>
    );
  }
}

SubGroupsMenu.propTypes = {
  onNoSubGroupClick: PropTypes.func.isRequired,
  onApplyLabels: PropTypes.func.isRequired,
  fileExtension: PropTypes.string.isRequired
};

export default SubGroupsMenu;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/subGroupsMenu/SubGroupsMenu.js